/**
 * routes
 *
 * @author Shigq
 * @date 2021/4/15 10:04
 */
import router, { asyncRoutes, constantRoutes, wildcardRoute, resetLocalRouter } from '@/router'
import { commonUtils } from '@libs/utils'

/**
 * assemble routes by menus
 *
 * @param menus
 * @returns {[]}
 */
function assembleRoutes(menus) {
  // param - retRoutes
  const retRoutes = []

  // ★★★ 写死前端模式：不根据后端 menus 过滤权限，直接原样保留 asyncRoutes 结构
  // 这样 /settlement 带 2 个 children 的嵌套结构 100% 不会被改变
  asyncRoutes.forEach(asyncRoute => {
    retRoutes.push(commonUtils.clone(asyncRoute))
  })

  // end of routes add wildcard route
  retRoutes.push(wildcardRoute)

  return retRoutes
}

/**
 * assemble nav routes by accessed routes
 *
 * @param routes
 * @returns {[]}
 */
const assembleNavRoutes = function(routes) {
  const retNavRoutes = []

  routes.forEach(route => {
    if (route.meta && route.meta.nav) {
      const retNavRoute = commonUtils.clone(route)
      if (route.children && route.children.length > 0) {
        retNavRoute.children.length = 0

        route.children.forEach(subRoute => {
          if (subRoute.meta && subRoute.meta.nav) {
            retNavRoute.children.push(subRoute)
          }
        })
      }

      retNavRoutes.push(retNavRoute)
    }
  })

  return retNavRoutes
}

export default {
  state: {
    routes: [],
    addRoutes: [],
    navRoutes: [],
    navActiveIdx: '',
    collapse: false
  },
  mutations: {
    SET_ROUTE: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
      router.options.routes = state.routes
    },
    RESET_ROUTES: (state) => {
      state.addRoutes = []
      state.routes = []
      state.navRoutes = []
      resetLocalRouter()
    },
    SET_NAV_ROUTE: (state, navRoutes) => {
      state.navRoutes = navRoutes
    },
    SET_NAV_ACTIVE_INDEX: (state, navRoutes) => {
      state.navActiveIdx = navRoutes
    }
  },
  actions: {
    initRoutes({ commit }) {
      return new Promise(resolve => {
        const menus = JSON.parse(localStorage.getItem('menus'))
        const accessedRoutes = assembleRoutes(menus)
        const navRoutes = assembleNavRoutes(accessedRoutes)

        commit('SET_ROUTE', accessedRoutes)
        commit('SET_NAV_ROUTE', navRoutes)
        resolve(accessedRoutes)
      })
    },
    setNavRouteIndex({ commit }, route) {
      commit('SET_NAV_ACTIVE_INDEX', route)
    }
  }
}
